<template>
  <div class="hero">
    <div class="landing" :class="landingClass">
      <!-- A 버전 레이아웃 -->
      <div v-if="variation === 'A'" class="guide">
        <div
          id="signupMain1"
          class="d-flex align-center justify-center w-112 h-24 white--text mb-4"
          style="background-color: #3a3a3a; line-height: 26px; border-radius: 30px; padding: 4px 12px 4px 12px">
          지인 추천율 80%
        </div>
        <h1>
          <b class="desktop-text" v-html="config.headline"></b>
          <b class="mobile-text" v-html="config.headlineMobile || config.headline"></b>
        </h1>
        <p v-if="isDesktop" v-html="config.subText" :class="subTextClass" style="line-height: 30px"></p>
        <p v-else v-html="config.subTextMobile || config.subText" :class="subTextClass" style="line-height: 30px"></p>
        <router-link v-if="userIsAuthenticated" to="/company/modads">
          <button class="signup newPrimaryBg" :style="config.buttonStyle">
            {{ config.buttonText }}
            <v-icon v-if="config.showIcon" style="color: #fff; margin: 0 0 2px 4px">chevron_right</v-icon>
          </button>
        </router-link>
        <button v-else class="signup newPrimaryBg" :style="config.buttonStyle" @click="clickLeadCtaBtn">
          {{ config.buttonText }}
          <v-icon v-if="config.showIcon" style="color: #fff; margin: 0 0 2px 4px">chevron_right</v-icon>
        </button>
        <v-row justify="center" align="center" style="max-height: 0px">
          <ConsultDialog :show.sync="showConsultDialog" />
          <LeadModal :showModal.sync="showLeadModal" />
        </v-row>
      </div>

      <!-- B/C/D 버전 레이아웃 -->
      <div v-else class="guide-wrapper" :style="wrapperStyle">
        <div class="guide variant-guide">
          <h1>
            <b class="desktop-text-B" v-html="config.headline"></b>
            <b class="mobile-text-B" v-html="config.headlineMobile || config.headline"></b>
          </h1>
          <p v-if="isDesktop" v-html="config.subText" :class="subTextClass"></p>
          <p v-else v-html="config.subTextMobile || config.subText" :class="subTextClass"></p>
          <router-link v-if="userIsAuthenticated" to="/company/modads">
            <button class="signup-B" :style="config.buttonStyle">
              {{ config.buttonText }}
            </button>
          </router-link>
          <button v-else class="signup-B" :style="config.buttonStyle" @click="clickLeadCtaBtn">
            {{ config.buttonText }}
          </button>
          <v-row justify="center" align="center" style="max-height: 0px">
            <ConsultDialog :show.sync="showConsultDialog" />
            <LeadModal :showModal.sync="showLeadModal" />
          </v-row>
        </div>
        <img v-if="isDesktop" :src="desktopImage" :style="variantImageStyle" alt="블로그 체험단 서비스" />
      </div>

      <!-- A 버전 이미지 -->
      <img v-if="variation === 'A' && isDesktop" :src="desktopImage" :style="aImageStyle" alt="블로그 체험단 서비스" />

      <!-- 모바일 이미지 -->
      <img v-if="!isDesktop" :src="mobileImage" :style="mobileImageStyle" alt="블로그 체험단" />
    </div>
    <Fab v-if="!showLeadModal" :showLeadModal.sync="showLeadModal" />
  </div>
</template>

<script>
import userMixin from '@/components/shared/userMixin';
import ConsultDialog from '@/components/company/ConsultDialog';
import LeadModal from '@/components/landing/modal/LeadModal.vue';
import Fab from './Fab.vue';

// 버전별 콘텐츠 설정
const VARIATION_CONFIG = {
  A: {
    badge: '지인 추천율 80%',
    badgeStyle: 'background-color: #3a3a3a',
    headline: '검증된 블로그 리뷰로<br />찾아오는 손님을 늘려보세요.',
    headlineMobile: '검증된 블로그 리뷰로<br />방문 손님을 늘려보세요.',
    subText: '영향력이 검증된 상위 블로거만 선별했습니다.<br />슈퍼멤버스 월별 구독으로 바빠지는 매장을 경험하세요!',
    buttonText: '무료 상담하기',
    buttonStyle: 'padding-left: 16px; line-height: 26px',
    showIcon: true,
    image: 'landing-logo.png',
    imageMobile: 'landing-logo-mobile.png',
  },
  B: {
    badge: null,
    badgeStyle: 'background-color: #ea2a3a',
    headline: '<span class="highlight">상위 1% 매장</span>의 매출 비밀,<br />지금 확인하세요.',
    headlineMobile: '<span class="highlight">상위 1% 매장</span>의<br />매출 비밀,<br />지금 확인하세요.',
    subText: '2만 명 사장님이 검증한 블로그 체험단의 성과',
    buttonText: '무료 상담하기',
    buttonStyle: 'background-color: #ff3b4b; padding: 16px; font-weight: bold;',
    showIcon: false,
    image: 'landing-logo-variant-B.png',
    imageMobile: 'landing-logo-mobile-variant-B.png',
  },
  C: {
    badge: null,
    badgeStyle: 'background-color: #0066ff',
    headline: '<span class="highlight">상위 1% 사장님</span>만 아는 매출 비밀,<br />지금 확인하세요.',
    headlineMobile: '<span class="highlight">상위 1% 사장님</span>만 아는<br />매출 비밀,<br />지금 확인하세요.',
    subText: '2만 명 사장님이 검증한 블로그 체험단의 성과',
    buttonText: '무료 상담하기',
    buttonStyle: 'background-color: #ff3b4b; padding: 16px; font-weight: bold;',
    showIcon: false,
    image: 'landing-logo-variant-B.png',
    imageMobile: 'landing-logo-mobile-variant-B.png',
  },
  D: {
    badge: null,
    headline: '자영업자들이 선택한 <span class="highlight">1위 체험단</span><br />성과로 답합니다.',
    headlineMobile: '자영업자들이 선택한<br /><span class="highlight">1위 체험단</span><br />성과로 답합니다.',
    subText: '2만 명의 사장님이 선택한 가장 확실한 마케팅 파트너 No.1',
    subTextMobile: '2만 명의 사장님이 선택한<br />가장 확실한 마케팅 파트너 No.1',
    buttonText: '무료 상담하기',
    buttonStyle: 'background-color: #ff3b4b; padding: 16px; font-weight: bold;',
    showIcon: false,
    image: 'landing-logo-variant-B.png',
    imageMobile: 'landing-logo-mobile-variant-B.png',
  },
};

export default {
  name: 'Landing',
  mixins: [userMixin],
  components: { ConsultDialog, LeadModal, Fab },
  async created() {
    // Hackle A/B 테스트 실행
    this.variation = await this.$getVariation(8);
  },

  mounted() {
    this.initializeTracking();
  },

  data() {
    return {
      showConsultDialog: false,
      showLeadModal: false,
      variation: 'A',
    };
  },

  computed: {
    isDesktop() {
      return this.$vuetify.breakpoint.mdAndUp;
    },

    config() {
      return VARIATION_CONFIG[this.variation] || VARIATION_CONFIG.A;
    },

    landingClass() {
      return this.variation !== 'A' ? 'variant-bg' : '';
    },

    subTextClass() {
      return this.variation === 'A' ? '' : 'landing-text-B';
    },

    desktopImage() {
      try {
        return require(`@/assets/img/landing/ceo-landing/${this.config.image}`);
      } catch {
        return require('@/assets/img/landing/ceo-landing/landing-logo.png');
      }
    },

    mobileImage() {
      try {
        return require(`@/assets/img/landing/ceo-landing/${this.config.imageMobile}`);
      } catch {
        return require('@/assets/img/landing/ceo-landing/landing-logo-mobile.png');
      }
    },

    wrapperStyle() {
      if (this.isDesktop) {
        return {
          maxWidth: '1200px',
          width: '100%',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          position: 'relative',
          padding: '0 60px',
        };
      }
      return {
        maxWidth: '1440px',
        width: '100%',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
      };
    },

    aImageStyle() {
      return {
        width: '596px',
        marginLeft: '70px',
      };
    },

    variantImageStyle() {
      return {
        position: 'absolute',
        width: '819px',
        height: '595px',
        right: '-20px',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 1,
      };
    },

    mobileImageStyle() {
      return {
        width: this.$vuetify.breakpoint.smAndUp ? '400px' : '100%',
        maxWidth: '400px',
        objectFit: 'contain',
      };
    },
  },

  methods: {
    initializeTracking() {
      // Pipedrive 스크립트
      const pipedriveScript = document.createElement('script');
      pipedriveScript.setAttribute('src', 'https://webforms.pipedrive.com/f/loader');
      document.head.appendChild(pipedriveScript);

      // 랜딩 페이지 추적
      window.dataLayer.push({
        event: 'onboardLanding',
        landingFrom: 'lead',
      });
    },

    clickLeadCtaBtn() {
      this.showLeadModal = true;

      // GTM 이벤트
      window.dataLayer.push({
        event: 'clickLeadCta',
        objectType: 'button',
        objectSection: 'main',
        objectId: 'openLeadForm',
        objectName: this.config.buttonText,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.hero {
  background-color: #fff;
}

.landing {
  display: flex;
  overflow: hidden;
  margin: 0 auto;
  padding-top: 270px;
  justify-content: center;
  padding-bottom: 300px;
  position: relative;

  &.variant-bg {
    background: #1f2130;
    height: 620px;
    padding: 0;
    align-items: center;

    @media (max-width: 724px) {
      height: auto;
      padding: 80px 20px;
    }
  }

  * {
    user-select: none;
    -moz-user-select: none;
    -webkit-user-drag: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
}

.guide {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0 16px;
  position: relative;

  h1 {
    line-height: 1.2;
    margin-bottom: 32px;
    font-weight: 300 !important;
    color: #0f1633;

    b {
      font-weight: 700;
    }
  }

  p {
    color: #1b2b43;
    margin-bottom: 56px;
    font-size: 15px;
    line-height: 1.79;
    letter-spacing: 0.01em;

    &.landing-text-B {
      color: #fff;
      font-size: 18px;
      font-weight: 500;
      line-height: 28px;
    }
  }

  &.variant-guide {
    h1 {
      margin-bottom: 16px;
    }

    p {
      margin-bottom: 48px;
    }
  }
}

.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 112px;
  height: auto;
  min-height: 24px;
  color: white;
  margin-bottom: 16px;
  line-height: 1.2;
  border-radius: 30px;
  padding: 4px 12px;
  white-space: nowrap;
}

.mobile-text {
  display: none;
}

.mobile-text-B {
  display: none;
  color: #fff;
  font-size: 28px;
  font-weight: 700;
}

::v-deep .highlight {
  color: #ff3b4b;
  font-weight: 700;
}

.desktop-text {
  display: inline;
}

.desktop-text-B {
  display: inline;
  color: #fff;
  font-size: 48px;
  line-height: normal;
  font-weight: 700;
}

.signup {
  width: 220px;
  height: 48px;
  border-radius: 24px;
  box-shadow: 0 12px 24px 0 rgba(16, 16, 16, 0.32);
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  color: #ffffff;
}

.signup-B {
  width: 220px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: #ffffff;
  line-height: 1;
}

.newPrimaryBg {
  background-color: #ea2a3a;
}

@media (max-width: 724px) {
  .landing {
    height: auto;
    min-height: 620px;
    padding: 50px 0 0 0;
    flex-direction: column;

    .guide-wrapper {
      flex-direction: column !important;
      text-align: center;

      .guide {
        align-items: center !important;
        text-align: center !important;
        margin-bottom: 20px;
      }
    }
  }

  .guide {
    text-align: center;
    align-items: center;

    h1 {
      font-size: 28px;
      margin-bottom: 30px;
      letter-spacing: 0.02em !important;
    }

    &.variant-guide {
      h1 {
        margin-bottom: 16px;
      }

      p {
        margin-bottom: 24px;
      }
    }

    p {
      margin-bottom: 50px;
      font-size: 14px;

      &.landing-text-B {
        color: #fff;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
      }
    }
  }

  .mobile-text,
  .mobile-text-B {
    display: inline !important;
  }

  .desktop-text,
  .desktop-text-B {
    display: none !important;
  }
}
</style>
